import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
      path: '/typ-library-buildings',
      name: 'Buildings Typology Library',
      component: () => import( '../views/TypLibraryBuildings.vue')
    },
    {
      path: '/typ-library-infrastructure',
      name: 'Infrastrucutre Typology Library',
      component: () => import( '../views/TypLibraryInfra.vue')
    },
    {
      path: '/insights',
      name: 'Insights',
      component: () => import( '../views/Insights.vue')
    },
    {
      path: '/calculator',
      name: 'Pre-Design Calculator',
      component: () => import( '../views/Calculator.vue')
    },
    // {
    //   path: '/case-studies',
    //   name: 'Case Studies',
    //   component: () => import( '../views/CaseStudies.vue')
    // },
    {
      path: '/contributors',
      name: 'Contributors',
      component: () => import( '../views/Contributors.vue')
    }
]

const router = new VueRouter({
  routes
})

export default router
